import { ArtSvg } from '@/components/ui/app-icon/art-svg.component';
import type { CandyShape } from '@/components/ui/app-icon/candy-art';
import { CANDY_ART } from '@/components/ui/app-icon/candy-art.data';
import type { ReactNode } from 'react';
import './candy-tile.css';
import './tile-motion.css';

/** Clu's body, beak and eye, and the agent colours the fan takes. */
const CLU = { disc: '#3B5AF7', beak: '#2A43DE', eye: '#0E1668' };
const AGENT_PINK = { disc: '#E0529C', beak: '#C23A82', eye: '#5C0E36' };
const AGENT_ORANGE = { disc: '#EE7B34', beak: '#D06120', eye: '#5E2608' };

function recolour(shapes: CandyShape[], to: typeof CLU): CandyShape[] {
  const swap: Record<string, string> = {
    [CLU.disc]: to.disc,
    [CLU.beak]: to.beak,
    [CLU.eye]: to.eye,
  };
  return shapes.map(([tag, attrs, colour, kind]) => [
    tag,
    attrs,
    typeof colour === 'string' ? (swap[colour] ?? colour) : colour,
    kind,
  ]);
}

const FAN_LEFT = recolour(CANDY_ART.robot ?? [], AGENT_PINK);
const FAN_RIGHT = recolour(CANDY_ART.robot ?? [], AGENT_ORANGE);

/**
 * The Agents tile's Clu: on hover two agent-coloured Clus fan out behind it,
 * one each side. Clu is drawn in colour in both styles, so the fan shows in
 * Plain too. Any other icon as it is.
 */
export function CluFan({
  iconName,
  size,
  children,
}: {
  iconName: string | undefined;
  size: number;
  children: ReactNode;
}) {
  if (iconName !== 'robot') return children;
  const fan = { width: size, height: size };
  return (
    <span className='candy-fan-host'>
      <ArtSvg
        shapes={FAN_LEFT}
        name='robot'
        aria-hidden='true'
        className='candy-fan candy-fan-l'
        style={fan}
      />
      <ArtSvg
        shapes={FAN_RIGHT}
        name='robot'
        aria-hidden='true'
        className='candy-fan candy-fan-r'
        style={fan}
      />
      <span className='candy-fan-front'>{children}</span>
    </span>
  );
}
